import { ErrorsNavigationContext, ErrorsNavigationContextType } from './ErrorsNavigationContext';
import { NavigableError } from 'services/errorsNavigation/errorsNavigation';
import { useErrorModal } from './useErrorModal';

export function ErrorsNavigationContextProvider<T extends NavigableError>({
  children,
  ErrorModalComponent,
  service,
}: Omit<ErrorsNavigationContextType<T>, 'useErrorModal'> & { children: React.ReactNode }) {
  const contextValue = {
    service,
    ErrorModalComponent,
    useErrorModal,
  };

  return <ErrorsNavigationContext.Provider value={contextValue}>{children}</ErrorsNavigationContext.Provider>;
}
